import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterIdsArraySearchValueObject} from './FilterIdsArraySearchValueObject.js'

export class FilterEquipmentsSearchValueObject extends ValueObject {
  #equipments

  constructor({equipments}) {
    super()
    this.#equipments = equipments
  }

  static create({equipments}) {
    return new FilterEquipmentsSearchValueObject({equipments: FilterIdsArraySearchValueObject.create(equipments)})
  }

  static createWithSanitize({config, equipments}) {
    return new FilterEquipmentsSearchValueObject({
      equipments: FilterIdsArraySearchValueObject.createWithSanitize({config, value: equipments})
    })
  }

  static createWithDefaultValue({config, equipments}) {
    const {DEFAULT_EQUIPMENTS_SEARCH} = config.get('searchFilters')

    return new FilterEquipmentsSearchValueObject({
      equipments: FilterIdsArraySearchValueObject.create({
        config,
        value: equipments ?? DEFAULT_EQUIPMENTS_SEARCH
      })
    })
  }

  static createQueryParams({config, equipments}) {
    const {DEFAULT_EQUIPMENTS_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterEquipmentsSearchValueObject({
      equipments: QueryParamSharedValueObject.createForPipeArray({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.EQUIPMENTS],
        value: equipments ?? DEFAULT_EQUIPMENTS_SEARCH
      })
    })
  }

  get isEmpty() {
    return this.#equipments.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#equipments.queryParam})
    }
  }

  get value() {
    return this.#equipments.value
  }

  toJSON() {
    return {
      equipments: this.#equipments.toJSON()
    }
  }
}
